import { type GrapeAPIErrorType } from 'components/hooks/GrapeAPIError'

export const OnboardingGenericErrorMessage = ({
  error,
  errors,
}: {
  error?: GrapeAPIErrorType;
  errors?: GrapeAPIErrorType[];
}) => {
  if (error?.status === 401) {
    return (
      <p>
        Your session has expired. Please refresh the page and sign in again to
        continue.
      </p>
    )
  } else if (error?.status === 409 || errors?.some((error) => error.status === 409)) {
    return (
      <p>
        Your enrollment event is inactive. Please refresh the page to see the latest update.
      </p>
    )
  } else {
    return (
      <p>
        There was an unknown problem that occurred during onboarding. Please
        reach out to support at{' '}
        <a href='mailto:support@thatch.com'>support@thatch.com</a> for more
        assistance.
        <br />
        {error?.requestId && <b>Request ID: {error.requestId}</b>}
        {errors && errors.length && errors.length > 0 && (
          <b>
            Request IDs: {errors.map((error) => error.requestId).join(', ')}
          </b>
        )}
      </p>
    )
  }
}
